import React, { useState, useEffect, useRef } from "react";
import LeaseApiService from "../../../services/apiService";
import { RiRefreshLine } from "react-icons/ri";
import { ClipLoader } from "react-spinners";
import { getName } from "../../../../Redux/selecters";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { FaSave, FaChevronLeft, FaEdit, FaTrash } from "react-icons/fa";
import UnitDetailsEdt from "../editLease/unitDetails";
import moment from "moment";
import Select from 'react-select';
import DatePicker from "react-datepicker";
import { HashLoader } from "react-spinners";
import "react-datepicker/dist/react-datepicker.css";
import { useCurrency } from '../../../../INVENTORY/Layouts/currencyContext';
import PaymentInvoices from "../paymentList";

const LeaseAgrementDash = () => {
    const apiService = new LeaseApiService();
    const userName = useSelector(getName);
    const [loader, setLoader] = useState(true);
    const { currencyPrecision } = useCurrency();
    const [loading, setloader] = useState(false);
    const [periodTo, setPeriodTo] = useState("");
    const [activeTab, setActiveTab] = useState(0);
    const [leaseTerm, setLeaseTerm] = useState("");
    const [periodFrom, setPeriodFrom] = useState("");
    const [FilterTab, setFilterTab] = useState(true);
    const [tentantTab, setTanantTab] = useState(false);
    const [tentantJoint, setTanantJoint] = useState(false);
    const [gridVisibility, setGridVisibility] = useState([true, false, false, false]);
    const [additionalCharges, setAdditionalCharges] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [propertylist, setPropertyList] = useState([]);
    const [customerList, setCUstomerList] = useState([]);
    const [leasingAgent, setLeasingAgent] = useState([]);
    const [taxCodeList, setTaxCodeList] = useState([]);
    const [remarksList, setRemarksList] = useState([]);
    const [InvoiceList, setInvoiceList] = useState([]);
    const [editIndex, setEditIndex] = useState(null);
    const [unitData, setUntData] = useState();
    const navigate = useNavigate();
    const location = useLocation();
    const gridRef = useRef();
    const leaseData = location.state;

    const [dataList, setDataList] = useState([{
        Property: [],
        Unit: [],
        noCommunity: "",
        rentPerAnum: "",
        unitClass: "",
        type: "",
        rentForPeriod: "",
        unitRefNo: "",
        bedRooms: "",
        FreeRent: "",
        discountPerc: "",
        totalArea: "",
        Landloard: "",
        taxCode: [],
        category: "",
        vat: "",
        discount: "",
        total: "",
        parkingNo: "",
        munAcNo: "",
        Parking: "",
        taxRate: "",
    }]);
    const [formData, setFormData] = useState({
        vatRecord: "",
        Property: [],
        Unit: [],
        noCommunity: "",
        rentPerAnum: "",
        unitClass: "",
        type: "",
        rentForPeriod: "",
        unitRefNo: "",
        bedRooms: "",
        FreeRent: "",
        discountPerc: "",
        totalArea: "",
        Landloard: "",
        taxCode: [],
        category: "",
        vat: "",
        discount: "",
        total: "",
        parkingNo: "",
        munAcNo: "",
        Parking: "",
        taxRate: "",
    });
    const [transData, setTransData] = useState({
        transectionDate: "",
        periodFrom: "",
        periodTo: "",
        noInstallment: "",
        CustomerName: "",
        CustomerAccount: "",
        leaseAgent: "",
        JointCustomerName: "",
        JointCustomerAccount: "",
        Broker: "",
        remarks: "",
        remarks2: "",
        arabicRemarks: "",
    });
    const totalVat = dataList?.reduce((sum, row) => sum + (parseFloat(row?.vat) || 0), 0);
    const totalRent = dataList?.reduce((sum, row) => sum + (parseFloat(row?.rentForPeriod) || 0), 0);
    const rentPerAnum = dataList?.reduce((sum, row) => sum + (parseFloat(row?.rentPerAnum) || 0), 0);
    const totalDiscount = dataList?.reduce((sum, row) => sum + (parseFloat(row?.FreeRent) || 0), 0);
    const calculatedTotal = dataList?.reduce((sum, row) => sum + (parseFloat(row?.total) || 0), 0);

    useEffect(() => {
        getUserList();
    }, [leaseData])

    const formatDate = (date) => {
        if (!date) return null;
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // month is 0-based
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    useEffect(() => {
        const today = new Date();
        const nextYear = new Date(today);
        nextYear.setFullYear(today.getFullYear() + 1);
        nextYear.setDate(nextYear.getDate() - 1);
        const formattedToday = today.toISOString().split("T")[0];
        const formattedNextYear = nextYear.toISOString().split("T")[0];

        setPeriodFrom(formattedToday);
        setPeriodTo(formattedNextYear);
        setTransData({
            transectionDate: formattedToday,
            periodFrom: formattedToday,
            periodTo: formattedNextYear,
            leaseTerm: calculateDaysDifference(formattedToday, formattedNextYear),
        })
        setLeaseTerm(calculateDaysDifference(formattedToday, formattedNextYear));
    }, [])

    const calculateDaysDifference = (from, to) => {
        const fromDate = new Date(from);
        const toDate = new Date(to);

        fromDate.setHours(0, 0, 0, 0);
        toDate.setHours(0, 0, 0, 0);

        return Math.floor((toDate - fromDate) / (1000 * 60 * 60 * 24)) + 1;
    }
    const getUserList = async () => {
        try {
            setLoader(true)
            const params = new URLSearchParams();
            params.append("dropdownTypes", "LASerPropertyName,LACustomerName,LALeasingAgent,LALeaseRemarks,VatPercentage");
            const customerRes = await apiService.getApiParamater("GET_PROPERT_DROP", `?${params?.toString()}`);
            setCUstomerList(customerRes?.data?.dropdowns?.LACustomerName);
            setPropertyList(customerRes?.data?.dropdowns?.LASerPropertyName);
            setLeasingAgent(customerRes?.data?.dropdowns?.LALeasingAgent);
            setRemarksList(customerRes?.data?.dropdowns?.LALeaseRemarks);
            setTaxCodeList(customerRes?.data?.dropdowns?.VatPercentage);
            if (leaseData) {
                const proParams = new URLSearchParams();
                proParams.append("DropdownFor", "LASerUnitNos");
                proParams.append("CascadValue", leaseData?.propertyNo);
                const proRes = await apiService.getApiParamater("GET_UNITNO_DROP", `?${proParams?.toString()}`);
                const selectedUnit = proRes?.data?.items?.find((dep) => dep.text === leaseData?.unitNo);
                const params = new URLSearchParams();
                params.append("Action", "GetUnitDetailsByUnitNo");
                params.append("PropertyNo", leaseData?.propertyNo);
                params.append("UnitRefNo", selectedUnit?.value);
                params.append("CustomerType", "NoInternal");
                const res = await apiService.getApiParamater("GET_UNITNO_DATA", `?${params?.toString()}`);
                setUntData(res?.data?.result?.data);
                let item = res?.data?.result?.data;
                const taxCode = customerRes?.data?.dropdowns?.VatPercentage?.find((dep) => dep.text === item?.VatDescription);

                const additionalParam = new URLSearchParams();
                additionalParam.append("Action", "GetChargesDetails");
                additionalParam.append("RentPerAnnum", item?.Rent_Per_Annum);
                const Additionalres = await apiService.getApiParamater("GET_UNITNO_DATA", `?${additionalParam?.toString()}`);
                if (Additionalres?.data?.result?.data?.length > 0) {
                    let leaseResponse = Additionalres?.data?.result?.data
                    setAdditionalCharges(leaseResponse);
                } else {
                    let leaseResponse = Additionalres?.data?.result?.data
                    setAdditionalCharges([leaseResponse]);
                }
                const taxParam = new URLSearchParams();
                taxParam.append("Action", "GetTaxRecordIdByTaxName");
                taxParam.append("TaxDescription", item?.VatDescription);
                const taxrecord = await apiService.getApiParamater("GET_UNITNO_DATA", `?${taxParam?.toString()}`);
                let recordId = taxrecord?.data?.result?.data?.RecordId;
                let Rate = taxrecord?.data?.result?.data?.Rate;
                let taxAmount = (item?.Rent_Per_Annum * Rate) / 100;
                let totalAmount = item?.Rent_Per_Annum + taxAmount;
                setFormData({
                    ...formData,
                    vatRecord: recordId,
                    taxRate: Rate,
                    noCommunity: "",
                    rentPerAnum: item?.Rent_Per_Annum,
                    unitClass: item?.Unit_Class,
                    type: item?.Unit_Type,
                    rentForPeriod: item?.Rent_Per_Annum,
                    unitRefNo: item?.Ref_No,
                    bedRooms: item?.Bedrooms === "0" ? "" : item?.Bedrooms,
                    FreeRent: "",
                    discountPerc: '',
                    totalArea: item?.Total_Area === "0" ? "" : item?.Total_Area,
                    Landloard: item?.Landlord === "0" ? "" : item?.Landlord,
                    taxCode: { label: taxCode?.text, value: taxCode?.value },
                    Property: { label: leaseData?.propertyName, value: leaseData?.propertyNo },
                    Unit: { label: selectedUnit?.text, value: selectedUnit?.value },
                    category: item?.Unit_Category,
                    vat: taxAmount,
                    discount: 0,
                    total: totalAmount,
                    parkingNo: item?.ParkingNo === "0" ? "" : item?.ParkingNo,
                    munAcNo: item?.MuncAcNo === "0" ? "" : item?.MuncAcNo,
                    Parking: item?.Parking === "0" ? "" : item?.Parking,
                });


            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error("Error fetching data:", error?.customerRes?.data?.message);
        }
    }
    const handleclearform = () => {
        setFormData({
            Property: [],
            Unit: [],
            noCommunity: "",
            rentPerAnum: "",
            unitClass: "",
            type: "",
            rentForPeriod: "",
            unitRefNo: "",
            bedRooms: "",
            FreeRent: "",
            discountPerc: "",
            totalArea: "",
            Landloard: "",
            taxCode: [],
            category: "",
            vat: "",
            discount: "",
            total: "",
            parkingNo: "",
            munAcNo: "",
            Parking: "",
        });
    }
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map(
            (_, index) => index === tabIndex
        );
        setGridVisibility(newGridVisibility);
    }
    const handleSave = async () => {
        try {
            setloader(true);
            if (!transData?.noInstallment) {
                toast.warning(`Please Enter No of Installment`);
                setloader(false);
                return;
            } else if (!transData?.CustomerAccount?.label) {
                toast.warning(`Please Select Primary Tenant`);
                setloader(false);
                return;
                // } else if (!transData?.leaseAgent?.label) {
                //     toast.warning(`Please Select Lease Agent`);
                //     setloader(false);
                //     return;
            } else if (!dataList[0]?.Property?.label) {
                toast.warning(`Please Select Unit details`);
                setloader(false);
                return;
                // } else if (!transData?.remarks2) {
                //     toast.warning(`Please Enter Remarks`);
                //     setloader(false);
                //     return;
            }
            const currentDatetimeUTC = new Date().toISOString();
            const unitDetailsList = await Promise.all(
                dataList.map(async (item) => {
                    const validation = new URLSearchParams();
                    validation.append("Action", "CheckAgreementValidPeriod");
                    validation.append("PeriodFrom", transData?.periodFrom);
                    validation.append("PeriodTo", transData?.periodTo);
                    validation.append("PropertyName", item?.Property?.label);
                    validation.append("UnitNo", item?.Unit?.label);
                    validation.append("UnitRefNo", item?.unitRefNo);

                    const validRes = await apiService.getApiParamater(
                        "GET_UNITNO_DATA",
                        `?${validation?.toString()}`
                    );

                    ;
                    if (validRes?.data?.result?.data?.Count > 0) {
                        toast.warning(
                            `Selected Unit ${item?.Unit?.label} Already Existed in lease Aggrement, in Given ${transData?.periodFrom} to ${transData?.periodTo}`
                        );
                        return null;
                    }

                    return {
                        recordId: 0,
                        leaseNo: "0",
                        groupId: 0,
                        proposalNo: "0",
                        propertyNo: item?.Property?.value,
                        propertyName: item?.Property?.label,
                        unitNo: item?.Unit?.label,
                        unitRefNo: item?.unitRefNo,
                        unitClass: item?.unitClass,
                        totalArea: parseFloat(item?.totalArea || 0),
                        rentPerAnnum: parseFloat(item?.rentPerAnum),
                        periodRent: parseFloat(item?.rentForPeriod),
                        discountPercent: parseFloat(item?.discountPerc) || 0,
                        discount: parseFloat(item?.FreeRent) || 0,
                        rent: parseFloat(item?.rentForPeriod),
                        vat: parseFloat(item?.vat),
                        total: parseFloat(item?.total),
                        taxCode: parseInt(item?.vatRecord),
                        taxPercent: parseFloat(item?.taxRate),
                        landlord: item?.Landloard || "0",
                        municipalityNo: item?.munAcNo || "0",
                        createdBy: userName,
                        createdOn: currentDatetimeUTC,
                        isAdded: true,
                        isUpdated: false,
                        rentNL: false,
                    };
                })
            );
            const formattedRows = unitDetailsList.filter(Boolean);
            if (formattedRows.length === 0) {
                setloader(false);
                return;
            }
            const selectedAdditional = additionalCharges?.filter(acc => acc.isSelected === true);

            const additionalChargesList = selectedAdditional.map((item, index) => ({
                recordId: 0,
                leaseNo: "0",
                groupId: 0,
                description: item?.Description,
                mId: item?.RecordId,
                drAcCode: transData?.CustomerAccount?.label,
                drAcName: transData?.CustomerName?.label,
                crAcCode: item?.AccountCode,
                crAcName: item?.CreditAccount,
                taxCode: item?.TaxCode,
                taxInclusive: item?.TaxInclusive,
                amount: item?.Amount,
                vat: item?.VAT,
                total: item?.Total,
                remarks: item?.Remarks,
                posting: item?.Posting,
                isDeposit: item?.IsDeposit,
                status: "0",
                psdId: 0,
                propertyNo: dataList[0]?.Property?.value,
                propertyName: dataList[0]?.Property?.label,
                unitNo: dataList[0]?.Unit?.label,
                unitRefNo: dataList[0]?.unitRefNo,
                tenantNo: transData?.CustomerAccount?.label,
                tenantName: transData?.CustomerName?.label,
                category: "",
                receiptNo: "0",
                receiptDate: currentDatetimeUTC,
                voucherNo: "0",
                voucherDate: currentDatetimeUTC,
                financialYear: "FY 2025",
                exp1: "0",
                exp2: "0",
                exp3: "0",
                exp4: "0",
                exp5: "0",
                modifiedBy: userName,
                modifiedOn: currentDatetimeUTC,
                createdBy: userName,
                createdOn: currentDatetimeUTC,
                vatDescription: item?.VATDescription,
                isChecked: true,
            }));
            const leaseAgreementMaster = {
                record_Id: 0,
                leaseNo: "0",
                leaseDate: transData?.periodFrom,
                leaseExpiry: transData?.periodTo,
                status: "0",
                tenantNo: transData?.CustomerAccount?.label,
                tenantName: transData?.CustomerName?.label,
                tenantTradeName: "",
                tenantBrand: "",
                totalArea: 0,
                totalAmount: 0,
                totalAmountByUser: 0,
                leaseTerm: leaseTerm?.toString(),
                leaseTermInMonths: parseInt(transData?.leaseTerm / 30),
                paymentTerm: "",
                paymentTermNoOfChqs: transData?.noInstallment,
                group_Id: 0,
                discountPercent: 0,
                discount: 0,
                taxCode: 0,
                taxInclusive: false,
                vatPercent: 0,
                stPercent: 0,
                st: 0,
                vat: 0,
                rent: 0,
                total: 0,
                modifiedBy: userName,
                modifiedOn: currentDatetimeUTC,
                createdBy: userName,
                createdOn: currentDatetimeUTC,
                transactionDate: transData?.transectionDate,
                rentFreeDays: 0,
                rentFreeAmount: 0,
                remarks: transData?.remarks2,
                arabicRemarks: transData?.arabicRemarks || "",
                leasingAgent: transData?.leaseAgent?.label || "",
                brokerName: transData?.Broker?.label || "",
                outletName: "",
            };
            const body = {
                leaseMain: {
                    leaseAgreementMaster: leaseAgreementMaster,
                    unitDetailsList: formattedRows,
                    additionalChargesList: additionalChargesList,
                    custPri_ContactNo:
                        transData?.CustomerAccount?.value?.ContactNo?.toString() || "",
                    custPri_Email: transData?.CustomerAccount?.value?.Email || "",
                    custPri_PassportID:
                        transData?.CustomerAccount?.value?.IDNo?.toString() || "",
                    custPri_Nationality:
                        transData?.CustomerAccount?.value?.Nationality?.toString() || "",
                    custPri_VatRegNo:
                        transData?.CustomerAccount?.value?.VATRegNo?.toString() || "",
                    custJoint_CustNo: transData?.JointCustomerAccount?.label || "",
                    custJoint_CustName: transData?.JointCustomerName?.label || "",
                    custJoint_ContactNo:
                        transData?.JointCustomerAccount?.value?.ContactNo?.toString() || "",
                    custJoint_Email: transData?.JointCustomerAccount?.value?.Email || "",
                    custJoint_PassportID:
                        transData?.JointCustomerAccount?.value?.IDNo?.toString() || "",
                    custJoint_Nationality:
                        transData?.JointCustomerAccount?.value?.Nationality?.toString() ||
                        "",
                    custJoint_VatRegNo:
                        transData?.JointCustomerAccount?.value?.VATRegNo?.toString() || "",
                },
            };
            ;
            const postRes = await apiService.post("CREATE_LEASE_AGRE", body);
            if (postRes?.data?.statusCode === 201) {
                // const token = localStorage.getItem("Token");
                // const DB = localStorage.getItem("DataBase")
                // if (!token) {
                //     alert("Auth token is missing! Unable to proceed.");
                //     return;
                // }
                // // const popupWidth = 1000;
                // // const popupHeight = 600;
                // // const popupLeft = (window.screen.width - popupWidth) / 2;
                // // const popupTop = (window.screen.height - popupHeight) / 2;
                // // const popup = window.open(
                // //   "",
                // //   "ReportPopup",
                // //   `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
                // // );

                // const newTab = window.open("Lease_Residiential/Print", "Lease_Residiential");
                // if (newTab) {
                //     const form = document.createElement("form");
                //     form.method = "POST";
                //     form.action = "https://procreports.apps.pro360erp.com/rdlreport/webform/DownloadDocPrints.aspx";
                //     form.target = "ReportPopup";

                //     const inputs = [
                //         { name: "authToken", value: token },
                //         { name: "_db", value: DB },
                //         { name: "reportName", value: "LeaseDocument" },
                //         { name: "LeaseNo", value: postRes?.data?.result?.leaseNo },
                //     ];

                //     inputs.forEach(({ name, value }) => {
                //         const input = document.createElement("input");
                //         input.type = "hidden";
                //         input.name = name;
                //         input.value = value;
                //         form.appendChild(input);
                //     });

                //     document.body.appendChild(form);
                //     form.submit();
                //     document.body.removeChild(form);
                // }
                toast.success(`${postRes?.data?.result?.leaseNo} Created successfully`);
                setloader(false);
                navigate("/Property/Management/LeaseAgreement");
            } else {
            }

            setloader(false);
        } catch (error) {
            setloader(false);

            console.error("Error Save Data", error);
        }
    }
    const handlePeriodToChange = ({ name, value }) => {
        const newToDate = value;
        if (new Date(newToDate) <= new Date(periodFrom)) {
            toast.warning("Period To date cannot be earlier than Period From date.");
            return;
        }
        const formattedDate = formatDate(newToDate);
        setPeriodTo(formattedDate);
        setLeaseTerm(calculateDaysDifference(periodFrom, formattedDate));
    }
    const handlePeriodFromChange = ({ name, value }) => {
        const newFromDate = value;
        const newToDate = new Date(newFromDate);
        newToDate.setFullYear(newToDate.getFullYear() + 1);

        const formattedFrom = formatDate(newFromDate);
        const formattedTo = formatDate(newToDate);

        setPeriodFrom(formattedFrom);
        setPeriodTo(formattedTo);
        setLeaseTerm(calculateDaysDifference(formattedFrom, formattedTo));
    }
    const handleInputChange = ({ name, value }) => {
        debugger
        if (name === 'transectionDate') {
            if (new Date(value) > new Date(periodFrom)) {
                toast.warning(`Transaction Date should be earlier than Period From`);
                return;
            }
            setTransData({ ...transData, [name]: formatDate(value) });
        }
        setTransData({ ...transData, [name]: value });
    }
    const handlefieldChange = (e) => {
        const { name, value } = e.target;
        if (name === "noInstallment") {
            if (value === 0) {
                toast.warning('No of Installment must be grater then or equal to "1');
                return;
            }
            if (dataList?.length > 0) {
                handlePaymentPlan(dataList, value);
            }
        }
        setTransData({ ...transData, [e.target.name]: e.target.value });
    }
    const handleCustomer = async (selectedOption) => {
        if (transData?.JointCustomerName?.label === selectedOption?.label) {
            toast?.warning(`Primary Customer Should be Different from Joint `)
            return;
        }
        else {
            const params = new URLSearchParams();
            params.append('Action', 'GetCustomerDetailsByTenantNo');
            params.append('TenantNo', selectedOption?.value);
            const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
            setTransData({
                ...transData,
                CustomerName: selectedOption,
                CustomerAccount: { label: selectedOption?.value, value: res?.data?.result?.data },
            });
        }
    }
    const handleCustomerAccount = async (selectedOption) => {
        if (transData?.JointCustomerAccount?.label === selectedOption?.label) {
            toast?.warning(`Primary Customer Should be Different from Joint `)
            return;
        } else {
            const params = new URLSearchParams();
            params.append('Action', 'GetCustomerDetailsByTenantNo');
            params.append('TenantNo', selectedOption?.label);
            const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
            setTransData({
                ...transData,
                CustomerAccount: { label: selectedOption?.label, value: res?.data?.result?.data },
                CustomerName: { label: selectedOption?.value, value: selectedOption?.label },
            });
        }
    }
    const handleJointCustomer = async (selectedOption) => {

        if (transData?.CustomerName?.label === selectedOption?.label) {
            toast?.warning(`Joint Customer Should be Different from Primary`)
            return;
        } else {
            const params = new URLSearchParams();
            params.append('Action', 'GetCustomerDetailsByTenantNo');
            params.append('TenantNo', selectedOption?.value);
            const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
            setTransData({
                ...transData,
                JointCustomerName: selectedOption,
                JointCustomerAccount: { label: selectedOption?.value, value: res?.data?.result?.data },
            });
        }
    }
    const handleJointCustomerAccount = async (selectedOption) => {
        if (transData?.CustomerAccount?.label === selectedOption?.label) {
            toast?.warning(`Joint Customer Should be Different from Primary`)
            return;
        } else {
            const params = new URLSearchParams();
            params.append('Action', 'GetCustomerDetailsByTenantNo');
            params.append('TenantNo', selectedOption?.label);
            const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
            setTransData({
                ...transData,
                JointCustomerAccount: { label: selectedOption?.label, value: res?.data?.result?.data },
                JointCustomerName: { label: selectedOption?.value, value: selectedOption?.label },
            });
        }
    }
    const handleAgentChange = (selectedOption) => {
        setTransData({
            ...transData,
            leaseAgent: selectedOption,
        });
    }
    const handleBrokerChange = (selectedOption) => {
        setTransData({
            ...transData,
            Broker: selectedOption,
        });
    }
    const handleRemarksChange = (selectedOption) => {
        setTransData({
            ...transData,
            remarks: selectedOption,
            remarks2: selectedOption?.value
        });
    }
    const handleCheckboxChange = async (index, field, value) => {
        const updated = [...additionalCharges];
        updated[index][field] = value;
        let data = updated[index]
        // If it's the select checkbox, also manage isSelected
        if (field === "isSelected") {
            updated[index].isSelected = value;
        }
        if (field === "Rate") {
            let qty = parseFloat(data?.Qty) || 0
            let vatdes = data?.VATDescription
            let amount = (parseFloat(value) * qty)
            if (vatdes) {
                const taxParam = new URLSearchParams();
                taxParam.append("Action", "GetTaxRecordIdByTaxName");
                taxParam.append("TaxDescription", vatdes);
                const taxrecord = await apiService.getApiParamater("GET_UNITNO_DATA", `?${taxParam.toString()}`);
                const result = taxrecord?.data?.result?.data;
                let VATRate = result.Rate || 0; // Save VAT % for future calc
                const vat = (parseFloat(amount || 0) * VATRate) / 100;
                let VAT = vat?.toFixed(currencyPrecision?.decimalNumbers);
                let Total = (parseFloat(amount || 0) + vat)?.toFixed(currencyPrecision?.decimalNumbers);
                updated[index].Rate = value;
                updated[index].VATRate = VATRate;
                updated[index].VAT = VAT;
                updated[index].Amount = amount;
                updated[index].Total = Total;
            } else {
                const vat = (parseFloat(amount || 0) * 0) / 100;
                let VAT = vat?.toFixed(currencyPrecision?.decimalNumbers);
                let Total = (parseFloat(amount || 0) + vat)?.toFixed(currencyPrecision?.decimalNumbers);
                updated[index].Rate = value?.toFixed(currencyPrecision?.decimalNumbers);
                updated[index].Amount = amount;
                updated[index].Total = Total;
            }
        }
        if (field === "Qty") {
            let rate = parseFloat(data?.Rate) || 0
            let vatdes = data?.VATDescription
            let amount = (parseFloat(value) * rate)
            if (vatdes) {
                const taxParam = new URLSearchParams();
                taxParam.append("Action", "GetTaxRecordIdByTaxName");
                taxParam.append("TaxDescription", vatdes);
                const taxrecord = await apiService.getApiParamater("GET_UNITNO_DATA", `?${taxParam.toString()}`);
                const result = taxrecord?.data?.result?.data;
                let VATRate = result.Rate || 0; // Save VAT % for future calc
                const vat = (parseFloat(amount || 0) * VATRate) / 100;
                let VAT = vat?.toFixed(currencyPrecision?.decimalNumbers);
                let Total = (parseFloat(amount || 0) + vat)?.toFixed(currencyPrecision?.decimalNumbers);
                updated[index].Qty = value;
                updated[index].VATRate = VATRate;
                updated[index].VAT = VAT;
                updated[index].Amount = amount;
                updated[index].Total = Total;
            } else {
                const vat = (parseFloat(amount || 0) * 0) / 100;
                let VAT = vat?.toFixed(currencyPrecision?.decimalNumbers);
                let Total = (parseFloat(amount || 0) + vat)?.toFixed(currencyPrecision?.decimalNumbers);
                updated[index].Qty = value;
                updated[index].Amount = amount;
                updated[index].Total = Total;
            }
        }
        setAdditionalCharges(updated);
    }
    const handleVatChange = async (index, selectedValue) => {
        const selectedOption = taxCodeList.find(tc => tc.value === selectedValue);
        if (!selectedOption) return;

        const taxParam = new URLSearchParams();
        taxParam.append("Action", "GetTaxRecordIdByTaxName");
        taxParam.append("TaxDescription", selectedOption.text);

        try {
            const taxrecord = await apiService.getApiParamater("GET_UNITNO_DATA", `?${taxParam.toString()}`);
            const result = taxrecord?.data?.result?.data;

            if (result) {
                setAdditionalCharges(prev => {
                    const updated = [...prev];
                    const row = { ...updated[index] };

                    row.TaxCodeValue = selectedValue;
                    row.VATDescription = selectedOption.text;
                    row.VATRate = result.Rate; // Save VAT % for future calc

                    const vat = (parseFloat(row.Amount || 0) * result.Rate) / 100;
                    row.VAT = vat?.toFixed(currencyPrecision?.decimalNumbers);
                    row.Total = (parseFloat(row.Amount || 0) + vat)?.toFixed(currencyPrecision?.decimalNumbers);

                    updated[index] = row;
                    return updated;
                });
            }
        } catch (error) {
            console.error("Failed to fetch VAT data:", error);
        }
    }
    const preventNegativeSign = (e) => {
        if (e.key === "-" || e.key === "+") {
            e.preventDefault();
        }
    }
    const handlePaymentPlan = async (rowData, value) => {
        const leaseRows = rowData?.length > 0 ? rowData : [rowData];
        const totalRent = leaseRows?.reduce((sum, row) => sum + (parseFloat(row?.rentAmount) || 0), 0);
        const total = leaseRows?.reduce((sum, row) => sum + (parseFloat(row?.total) || 0), 0);
        const vat = leaseRows?.reduce((sum, row) => sum + (parseFloat(row?.vat) || 0), 0);
        // comma separated values
        const propertyNos = [...new Set(leaseRows.map((i) => i.Property?.value).filter(Boolean))].join(',');
        const propertyNames = [...new Set(leaseRows.map((i) => i.Property?.label).filter(Boolean))].join(',');
        const unitNos = [...new Set(leaseRows.map((i) => i.Unit?.label).filter(Boolean))].join(',');
        const taxCodes = [...new Set(leaseRows.map((i) => i.taxCode?.value).filter(Boolean))].join(',');
        const taxPercents = [...new Set(leaseRows.map((i) => i.taxRate).filter((v) => v !== undefined))].join(',');
        const params = new URLSearchParams();
        params.append('PropertyNo', propertyNos);
        params.append('PropertyName', propertyNames);
        params.append('UnitNo', unitNos);
        params.append('TaxCode', taxCodes);
        params.append('VATPercent', taxPercents);
        params.append('PeriodFrom', periodFrom);
        params.append('PeriodTo', periodTo);
        params.append('Rent', totalRent);
        params.append('VatAmount', vat);
        params.append('TotalAmount', total);
        params.append('DecimalFormat', currencyPrecision?.decimalNumbers || 2);
        params.append('PaymentTermNoOfChqs', parseInt(value || transData?.noInstallment) || 2);
        params.append('IsEdit', false);
        params.append('PayId', '');
        params.append('CreatedBy', userName);
        params.append('STPercent', 0.0);
        const res = await apiService.getApiParamater('GET_PAYMENT_PLAN', `?${params?.toString()}`);
        // API returns an array for multiple installments, a single object for one row — always keep full payload (never data[0]).
        const planData = res?.data?.result?.data;
        setInvoiceList(planData == null ? [] : planData);
    }
    return (
        <div className="p-3">
            <div className="d-flex mb-3">
                <div className="col-lg-8 nav nav-pills overslid d-flex gap-4">
                    <div
                        className={`dashitems sidebar-text center ${activeTab === 0 ? "sideActive" : ""
                            }`}
                        onClick={() => handleTabClick(0)}
                    >
                        Transaction and Tenant
                    </div>
                    <div
                        className={`dashitems sidebar-text center  ${activeTab === 1 ? "sideActive" : ""
                            }`}
                        onClick={() => handleTabClick(1)}
                    >
                        Unit Details
                    </div>
                    <div
                        className={`dashitems sidebar-text center  ${activeTab === 2 ? "sideActive" : ""
                            }`}
                        onClick={() => handleTabClick(2)}
                    >
                        Additional Charges
                    </div>

                    <div className={`dashitems sidebar-text center  ${activeTab === 3 ? 'sideActive' : ''}`} onClick={() => handleTabClick(3)}>
                        Payment Plan
                    </div>
                </div>
                <div className="col-lg-4 d-flex gap-1">
                    {loading === true ? (
                        <div className="mainbtn flex-end gap-2 w-50">
                            <ClipLoader color="#ffffff" className="mt-1" size={25} />
                        </div>
                    ) : (
                        <div className="mainbtn flex-end gap-2 w-50" onClick={handleSave}>
                            <FaSave color="#fff" className="center mt-2 mx-2" />
                            <div className="center">Save</div>
                        </div>
                    )}
                    <div className="mainbtnRed flex-end gap-2 w-50"
                        onClick={handleclearform}
                    >
                        <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                        <div className="center">Reset</div>
                    </div>
                    <div className="mainbtnSecondary flex-end gap-2 w-50"
                        onClick={() => navigate("/Property/Management/LeaseAgreement")}
                    >
                        <FaChevronLeft color="#fff" className="center mt-2 mx-2" />
                        <div className="center">Back</div>
                    </div>
                </div>
            </div>
            {gridVisibility[0] && (
                <div className=''>
                    <div className="cost-center-section mt-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setFilterTab(!FilterTab)}>
                            <div className='h6 pt-1'>Transaction Details</div>
                        </div>
                        <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                            <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                                {loader === true ?
                                    <div className="center p-5"><HashLoader color="#6e5199" /></div> :
                                    <div className="form-group grid-contain ">
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Transaction Date</label>
                                            <DatePicker
                                                todayButton="Today"
                                                selected={transData?.transectionDate}
                                                onChange={(date) => handleInputChange({ name: 'transectionDate', value: date })}
                                                dateFormat="dd-MMM-yyyy"
                                                className="p-2 form-control w-100"
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="periodFrom" className="form-label pt-1 start">Period From</label>
                                            <DatePicker
                                                todayButton="Today"
                                                selected={periodFrom}
                                                onChange={(date) => handlePeriodFromChange({ name: 'periodFrom', value: date })}
                                                dateFormat="dd-MMM-yyyy"
                                                className="p-2 form-control w-100"
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="periodTo" className="form-label pt-1 start">Period To</label>
                                            <DatePicker
                                                todayButton="Today"
                                                selected={periodTo}
                                                onChange={(date) => handlePeriodToChange({ name: 'periodTo', value: date })}
                                                dateFormat="dd-MMM-yyyy"
                                                className="p-2 form-control w-100"
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="leaseTerm" className="form-label pt-1 start">Lease Term</label>
                                            <input
                                                type="text"
                                                className="p-2 form-control w-75"
                                                name="leaseTerm"
                                                value={leaseTerm}
                                                readOnly
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">No. Of Installments</label>
                                            <input type="number" className="p-2 form-control w-75" name="noInstallment" min={1}
                                                value={transData?.noInstallment} onChange={handlefieldChange} />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Select Remarks</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={transData.remarks}
                                                options={remarksList?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                                                onChange={(selectedOption) => handleRemarksChange(selectedOption)}
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Remarks</label>
                                            <input type="text" className="p-2 form-control w-75" name="remarks2"
                                                onChange={handlefieldChange}
                                                value={transData?.remarks2} />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Arabic Remarks</label>
                                            <input type="text" className="p-2 form-control w-75" name="arabicRemarks"
                                                onChange={handlefieldChange}
                                                value={transData?.arabicRemarks} />
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="cost-center-section mt-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setTanantTab(!tentantTab)}>
                            <div className='h6 pt-1'>Tenant Primary Details</div>
                        </div>
                        <div className={`slide-content ${tentantTab ? 'open' : 'closed'}`}>
                            <div className={`border-box2 p-3 ${tentantTab ? 'slide-in' : 'slide-out'}`}>
                                {loader === true ?
                                    <div className="center p-5"><HashLoader color="#6e5199" /></div> :
                                    <div className="form-group grid-contain ">
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Name</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={transData.CustomerName}
                                                options={customerList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                                onChange={(selectedOption) => handleCustomer(selectedOption)}
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Acc/ Code</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={transData.CustomerAccount}
                                                options={customerList?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                                                onChange={(selectedOption) => handleCustomerAccount(selectedOption)}
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact No.</label>
                                            <input type="text" className="p-2 form-control w-75" name="periodto" value={transData?.CustomerAccount?.value?.ContactNo} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Email</label>
                                            <input type="email" className="p-2 form-control w-75" name="leaseTerm" value={transData?.CustomerAccount?.value?.Email} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Passport / ID</label>
                                            <input type="text" className="p-2 form-control w-75" name="installments" value={transData?.CustomerAccount?.value?.IDNo} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Nationality</label>
                                            <input type="text" className="p-2 form-control w-75" name="remarks" value={transData?.CustomerAccount?.value?.Nationality} readOnly />

                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Vat Reg No</label>
                                            <input type="text" className="p-2 form-control w-75" name="remarks" value={transData?.CustomerAccount?.value?.VATRegNo} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Leasing Agent</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={transData.leaseAgent}
                                                options={leasingAgent?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                                                onChange={(selectedOption) => handleAgentChange(selectedOption)}
                                            />
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="cost-center-section my-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setTanantJoint(!tentantJoint)}>
                            <div className='h6 pt-1'>Tenant Joint Details</div>
                        </div>
                        <div className={`slide-content ${tentantJoint ? 'open' : 'closed'}`}>
                            <div className={`border-box2 p-3 ${tentantJoint ? 'slide-in' : 'slide-out'}`}>
                                {loader === true ?
                                    <div className="center p-5"><HashLoader color="#6e5199" /></div> :
                                    <div className="form-group grid-contain ">
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Name</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={transData.JointCustomerName}
                                                options={customerList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                                onChange={(selectedOption) => handleJointCustomer(selectedOption)}
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Acc/ Code</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={transData.JointCustomerAccount}
                                                options={customerList?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                                                onChange={(selectedOption) => handleJointCustomerAccount(selectedOption)}
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact No.</label>
                                            <input type="text" className="p-2 form-control w-75" name="periodto" value={transData?.JointCustomerAccount?.value?.ContactNo} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Email</label>
                                            <input type="email" className="p-2 form-control w-75" name="leaseTerm" value={transData?.JointCustomerAccount?.value?.Email} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Passport / ID</label>
                                            <input type="text" className="p-2 form-control w-75" name="installments" readOnly value={transData?.JointCustomerAccount?.value?.IDNo} />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Nationality</label>
                                            <input type="text" className="p-2 form-control w-75" name="remarks" value={transData?.JointCustomerAccount?.value?.Nationality} readOnly />

                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Vat Reg No</label>
                                            <input type="text" className="p-2 form-control w-75" name="remarks" value={transData?.JointCustomerAccount?.value?.VATRegNo} readOnly />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Broker</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={transData.Broker}
                                                options={leasingAgent?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                                                onChange={(selectedOption) => handleBrokerChange(selectedOption)}
                                            />
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {gridVisibility[1] && (
                <UnitDetailsEdt rentPerAnum={rentPerAnum} calculatedTotal={calculatedTotal} totalRent={totalRent} totalVat={totalVat} totalDiscount={totalDiscount}
                    dataList={dataList} selectedIndex={selectedIndex} setSelectedIndex={setSelectedIndex} formData={formData} setFormData={setFormData}
                    taxCodeList={taxCodeList} propertylist={propertylist} setAdditionalCharges={setAdditionalCharges} setUntData={setUntData} transData={transData}
                    handleclearform={handleclearform} setDataList={setDataList} setEditIndex={setEditIndex} editIndex={editIndex} handleUnitPaymentPlan={handlePaymentPlan}
                />
            )}
            {gridVisibility[2] && (
                <div
                    className="table-container my-3"
                    style={{ overflowX: "auto", height: "700px" }}
                >
                    <table>
                        <thead className="dynoTable">
                            <tr>
                                <th>Select</th>
                                <th>Description</th>
                                <th>Rate</th>
                                <th>Qty</th>
                                <th>Amount</th>
                                <th>Tax Code</th>
                                <th>Vat</th>
                                <th>Total</th>
                                <th>Posting</th>
                                <th>Remarks</th>
                                <th>From Rent</th>
                            </tr>
                        </thead>
                        <tbody>
                            {additionalCharges?.map((row, index) => (
                                <tr key={row.RecordId}>
                                    {/* Select */}
                                    <td className="m-0 p-0 text-center">
                                        <div className="center mt-1">
                                            <input
                                                type="checkbox" className="center"
                                                checked={row.isSelected || false}
                                                onChange={(e) =>
                                                    handleCheckboxChange(index, "isSelected", e.target.checked)
                                                }
                                                style={{ width: "20px", height: "20px" }}
                                            />
                                        </div>
                                    </td>

                                    {/* Description */}
                                    <td className="m-0 p-0">
                                        <input
                                            className="p-1"
                                            value={row.Description}
                                            disabled
                                            style={{ width: "400px" }}
                                        />
                                    </td>

                                    {/* Rate */}
                                    <td className="m-0 p-0">
                                        <input
                                            className="p-1"
                                            type="number" onKeyDown={preventNegativeSign}
                                            value={row.Rate || ""}
                                            onChange={(e) =>
                                                handleCheckboxChange(index, "Rate", e.target.value)
                                            }
                                            style={{ width: "100px" }}
                                        />
                                    </td>

                                    {/* Qty */}
                                    <td className="m-0 p-0">
                                        <input
                                            className="p-1" onKeyDown={preventNegativeSign}
                                            type="number"
                                            value={row.Qty || ""}
                                            onChange={(e) =>
                                                handleCheckboxChange(index, "Qty", e.target.value)
                                            }
                                            style={{ width: "100px" }}
                                        />
                                    </td>

                                    {/* Amount */}
                                    <td className="m-0 p-0">
                                        <input
                                            className="p-1"
                                            type="text"
                                            value={row.Amount?.toFixed(currencyPrecision?.decimalNumbers) || ""}
                                            disabled
                                            style={{ width: "120px" }}
                                        />
                                    </td>

                                    {/* Tax Code */}
                                    <td className="m-0 p-0">
                                        <select
                                            className="p-1"
                                            value={row.TaxCodeValue || row?.VATDescription || ""}
                                            onChange={(e) => handleVatChange(index, e.target.value)}
                                            style={{ width: "300px" }}
                                        >
                                            <option value="">Select Tax Code</option>
                                            {taxCodeList.map((tax) => (
                                                <option key={tax.value} value={tax.value}>
                                                    {tax.text}
                                                </option>
                                            ))}
                                        </select>
                                    </td>

                                    {/* Vat */}
                                    < td className="m-0 p-0" >
                                        <input
                                            className="p-1"
                                            value={row.VAT?.toFixed(currencyPrecision?.decimalNumbers) || 0}
                                            disabled
                                            style={{ width: "100px" }}
                                        />
                                    </td>

                                    {/* Total */}
                                    <td className="m-0 p-0">
                                        <input
                                            className="p-1"
                                            value={row.Total?.toFixed(currencyPrecision?.decimalNumbers) || "0.00"}
                                            disabled
                                            style={{ width: "120px" }}
                                        />
                                    </td>

                                    {/* Posting */}
                                    <td className="m-0 p-0 text-center">
                                        <input
                                            type="checkbox"
                                            checked={row.Posting || false}
                                            onChange={(e) =>
                                                handleCheckboxChange(index, "Posting", e.target.checked)
                                            }
                                            style={{ width: "20px", height: "20px" }}
                                        />
                                    </td>

                                    {/* Remarks */}
                                    <td className="m-0 p-0">
                                        <input
                                            className="p-1"
                                            value={row.Remarks || ""}
                                            onChange={(e) =>
                                                handleCheckboxChange(index, "Remarks", e.target.value)
                                            }
                                            style={{ width: "400px" }}
                                        />
                                    </td>

                                    {/* From Rent */}
                                    <td className="m-0 p-0 text-center">
                                        <input
                                            type="checkbox" className="w-100"
                                            checked={row.IsDeposit || false}
                                            onChange={(e) =>
                                                handleCheckboxChange(index, "IsDeposit", e.target.checked)
                                            }
                                            style={{ width: "20px", height: "20px" }}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div >
            )}
            {gridVisibility[3] && <PaymentInvoices InvoiceList={InvoiceList} />}
        </div>
    );
};
export default LeaseAgrementDash;
